var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty"},[_c('div',{staticClass:"empty__description"},[_c('AzIcon',{staticClass:"empty__icon",attrs:{"icon-name":"search","size":"largest"}}),_vm._v(" "),_c('h4',{staticClass:"empty__text"},[_vm._v(" "+_vm._s(_vm.translate('search.noResults'))+" "+_vm._s(_vm.term)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }